<template>
  <div id="promotionRuleEdit">
    <div class="container">

      <div class="page-title">
        <span class="name">{{ data ? $to(data.name) : '' }}</span>
        <button class="save btn btn-primary" @click="save"
          v-if="$store.getters.loggedUserHasModifyPermission">{{ $t("save") }}</button>
      </div>

      <Tabs>
        <TabSection :title="$t('tag')" v-if="ready">
          <div class="columns">

            <div class="column">
              <div class="group">
                <LocalizedInput :title="$t('name')" :translate="data.name" />
              </div>

              <div class="group">
                <label>{{ $t('color') }}</label>
                <input type="text" v-model="data.color">
              </div>

              <div class="group">
                <label>{{ $t('public') }}?</label>
                <select v-model="data.public">
                  <option :value="true">{{ $t('yes') }}</option>
                  <option :value="false">{{ $t('no') }}</option>
                </select>
              </div>

            </div>
          </div>
        </TabSection>
      </Tabs>

      <div class="footer-actions" v-if="$store.getters.loggedUserHasModifyPermission">
        <button class="btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import LocalizedInput from "@/components/tools/LocalizedInput";
  import { mapActions } from "vuex";

  export default {
    name: "promotionRuleEdit",
    components: { LocalizedInput },

    data() {
      return {
        entityName: 'tags',
        inventory: null,
        data: null
      }
    },

    computed: {
      inventoryReference() {
        return this.$store.state.contextCompany ? this.$store.state.contextCompany.nameCanonical : this.inventory.id;
      },
      tagId() {
        return this.$route.query.id;
      },
      ready() {
        return !!this.data;
      }
    },

    validate: {

    },

    async mounted() {
      this.inventory = await this.$store.getters.getContextInventory;

      if (this.tagId) {
        showSpinner();
        let response = await this.getOneInventoryEntity({ entity: this.entityName, inventory: this.inventoryReference, id: this.tagId });
        if (response) {
          this.data = response;
        }
        hideSpinner();
      } else {
        this.data = {
          id: null,
          name: { fr: "", en: "" },
          color: "",
          public: false,
        }
      }
      if (!this.$store.getters.loggedUserHasModifyPermission) {
        window.lockFields();
      }
    },

    methods: {

      ...mapActions(["getOneInventoryEntity", "getManyInventoryEntity", "createInventoryEntity", "saveInventoryEntity"]),

      async save() {
        if (!this.$validate.valid()) {
          toast("TODO translation", "warning");
          this.$validate.validateAllOnce();
          return;
        }

        this.$store.commit("showSpinner", true);
        let response = this.data.id ?
          await this.saveInventoryEntity({ entity: this.entityName, inventory: this.inventoryReference, data: this.data, id: this.data.id }) :
          await this.createInventoryEntity({ entity: this.entityName, inventory: this.inventoryReference, data: this.data });
        this.$store.commit("showSpinner", false);

        if (!response) {
          toast(this.$t("inventory_action.error.save").replace('XXX', this.$t(`inventory_action.entities.${this.entityName}`)), "error")
        } else {
          toast(this.$t("inventory_action.success.save_f").replace('XXX', this.$t(`inventory_action.entities.${this.entityName}`)), 'success')
        }

        await this.$router.push(this.$router.buildContext("/tags"));
      }
    }
  }
</script>

<style lang="scss" scoped>
  #promotionRuleEdit {
    display: flex;
  }
</style>